import { bind } from 'decko'
import { LiveElement, LiveNodeList } from 'live-node-list'
import { parsePhoneNumber } from 'libphonenumber-js'

export default class PhoneFormatting {
  phoneContainers = new LiveNodeList('.telephone-format')

  constructor() {
    if (!this.phoneContainers) {
      return
    }
    this.registerListeners()
  }

  /**
   *
   */
  @bind
  registerListeners() {
    this.phoneContainers.forEach(element => {
      this.formatPhone(element)
    })
  }

  @bind
  formatPhone(element) {
    try {
      const phoneNumber = parsePhoneNumber(
        element.querySelector('.telephone-format__phone').innerText,
        'GB',
      )
      if (phoneNumber.isValid()) {
        element
          .querySelector('.telephone-format__link')
          .setAttribute(
            'href',
            'tel:' + phoneNumber.formatInternational().replace(' ', ''),
          )
      }
    } catch (error) {
      console.error('Error formatting phone number', error)
    }
  }
}
